// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_eMV","footer":"styles_footer__1rZOk","passCodeTooltip":"styles_passCodeTooltip__1YTvo"};